import phq9Score from './phq9-score';
import mmas4Score from './mmas4-score';

export {
  phq9Score,
  mmas4Score
}



// WEBPACK FOOTER //
// ./src/business-logic/index.js